(function () {
  if (!customElements.get('product-discount-countdown-timer')) {
    class ProductDiscountCountdownTimer extends HTMLElement {
      constructor() {
        super();
        this.countDownDate = null;
      }

      connectedCallback() {
        const timezone = this.dataset.timezone;
        const dateParts = this.dataset.date.split('-');
        const day = parseInt(dateParts[0], 10);
        const month = parseInt(dateParts[1], 10);
        const year = parseInt(dateParts[2], 10);
        const time = this.dataset.time || '0:0';
        const [tarhour, tarmin] = time.split(':').map(Number);
        const dateString = month + '/' + day + '/' + year + ' ' + tarhour + ':' + tarmin + ' GMT' + timezone;

        this.countDownDate = new Date(dateString).getTime();
        this.daySingular = this.dataset.daySingular || 'day';
        this.dayPlural = this.dataset.dayPlural || 'days';

        this.daysEl = this.querySelector('[data-days]');
        this.hoursEl = this.querySelector('[data-hours]');
        this.minutesEl = this.querySelector('[data-minutes]');
        this.secondsEl = this.querySelector('[data-seconds]');

        this.tick();
      }

      tick() {
        if (!this.countDownDate) return;

        const distance = this.countDownDate - Date.now();

        if (distance < 0) {
          this.updateDisplay(0, 0, 0, 0);
          const card = this.closest('.product-discount-countdown');
          if (card) {
            card.style.display = 'none';
          }
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        this.updateDisplay(days, hours, minutes, seconds);
        setTimeout(() => this.tick(), 1000);
      }

      updateDisplay(days, hours, minutes, seconds) {
        if (this.daysEl) {
          const dayLabel = days === 1 ? this.daySingular : this.dayPlural;
          this.daysEl.textContent = days + ' ' + dayLabel;
        }
        if (this.hoursEl) {
          this.hoursEl.textContent = this.pad(hours) + ':';
        }
        if (this.minutesEl) {
          this.minutesEl.textContent = this.pad(minutes) + ':';
        }
        if (this.secondsEl) {
          this.secondsEl.textContent = this.pad(seconds);
        }
      }

      pad(value) {
        return value < 10 ? '0' + value : String(value);
      }
    }

    customElements.define('product-discount-countdown-timer', ProductDiscountCountdownTimer);
  }

  function initCopyButtons() {
    document.querySelectorAll('[data-copy-trigger]').forEach((button) => {
      if (button.dataset.copyInit) return;
      button.dataset.copyInit = 'true';

      button.addEventListener('click', function () {
        const container = this.closest('.product-discount-countdown');
        const codeEl = container && container.querySelector('[data-discount-code]');
        if (!codeEl) return;

        const code = codeEl.textContent.trim();

        const onSuccess = () => {
          this.classList.add('is-copied');
          setTimeout(() => {
            this.classList.remove('is-copied');
          }, 2000);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(onSuccess.bind(this)).catch(() => {
            fallbackCopy(code, onSuccess.bind(this));
          });
        } else {
          fallbackCopy(code, onSuccess.bind(this));
        }
      });
    });
  }

  function fallbackCopy(text, callback) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      callback();
    } catch (e) {
      console.error('Copy failed:', e);
    }
    document.body.removeChild(textarea);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCopyButtons);
  } else {
    initCopyButtons();
  }

  document.addEventListener('shopify:section:load', initCopyButtons);
})();
